<template>
  <div class="school-data-wrap" :class="{'school-data-wrap-other':artSchoolCondition.condition===2}">
    <div v-if="!istype" :class="{'school-out-div':artSchoolCondition.condition===2}">
      <div
        class="school-info"
        :class="{'school-info-other':artSchoolCondition.condition===2}"
        v-for="(item, index) in schoolData.data.records"
        :key="index"
      >
        <div class="info-logo">
          <router-link
            tag="a"
            target="_blank"
            :to="{
              path: '/main/schoolDetail/' + $route.name,
              query: { item: item.gb, zyz: item.zyz,pc:item.createPc }
            }"
          >
            <img :src="item.logo" alt="院校logo" width="100%" height="100%" />
          </router-link>
        </div>
        <div class="info-introduce" :class="{'info-introduce-other':artSchoolCondition.condition===2}">
          <div class="school-name">
            <router-link
              tag="a"
              target="_blank"
              :to="{
                path: '/main/schoolDetail/' + $route.name,
                query: { item: item.gb, zyz: item.zyz,pc:item.createPc }
              }"
            >
              <h3>{{ item.yxmc }} <span v-if="$route.path === '/main/yshSchoolRecommend'">[{{ item.zyz }}]专业组</span> </h3>
            </router-link>
            <div class="school-lqgl" v-if="$route.path === '/main/yshSchoolRecommend'">
              (录取率:{{ item.lqgl }}%)
            </div>
          </div>
          <div class="school-category">
            <div class="category-wrap">
              <div class="category-item top-positon">
                往年批次:
                <span>{{ item.pc === ''?'-': item.pc===0?"本科提前批":item.pc===7?"高职专科批":""}}</span>
              </div>
              <div class="category-item">
                院校属性:
                <span v-if="item.sf985 !== '0'">985&nbsp;</span>
                <span v-if="item.sf211 !== '0'">211&nbsp;</span>
                <span v-else>普通高校</span>
              </div>
              <div class="category-item">所在地区:{{ item.yxdq }}</div>
              <!-- <div class="category-item">
                <button
                  type="button"
                  class="deleteSchool"
                  @click="deleteSchool(item)"
                  v-if="item.collect"
                >
                  取消收藏
                </button>
                <button
                  type="button"
                  class="addSchool"
                  @click="addSchool(item)"
                  v-else
                >
                  加入收藏
                </button>
              </div> -->
            </div>
            <div class="info-data-wrap" v-if="artSchoolCondition.condition!==2">
              <table class="info-data">
                <tr>
                  <th rowspan="2">年度</th>
                  <th colspan="3">综合成绩</th>
                  <el-tooltip placement="top">
                    <div slot="content">
                      我的综合成绩就是分别把当年的文化成绩和专业成绩折算成<br />表中年度对应成绩后，再按占比进行计算
                    </div>
                    <th rowspan="2">我的综合成绩</th>
                  </el-tooltip>
                  <th colspan="2">招生计划</th>
                  <th rowspan="2">操作</th>
                </tr>
                <tr>
                  <th>最低分</th>
                  <th>平均分</th>
                  <th>最高分</th>
                  <th>当年</th>
                  <th>今年</th>
                </tr>
                <tr v-for="(innerItem, innerIndex) in item.examples" :key="innerIndex">
                  <td>{{ innerItem.year }}</td>
                  <td>
                    {{
                      innerItem.lowestScore == 0 ? "-" : innerItem.lowestScore
                    }}
                  </td>
                  <td>
                    {{
                      innerItem.averageScore == null
                        ? "-"
                        : innerItem.averageScore
                    }}
                  </td>
                  <td>
                    {{
                      innerItem.highestScore == null
                        ? "-"
                        : innerItem.highestScore
                    }}
                  </td>
                  <td v-if="innerIndex===0" rowspan="3">
                    {{ (innerItem.myScore == null || innerItem.myScore == 0) ? "-" : innerItem.myScore }}
                  </td>
                  <td>
                    {{
                      innerItem.currentPlan == 0 ? "-" : innerItem.currentPlan
                    }}
                  </td>
                  <td v-if="innerIndex === 0" rowspan="3">
                    {{ innerItem.thisPlan == null ? "-" : innerItem.thisPlan }}
                  </td>
                  <td v-if="innerIndex===0" rowspan="3">
                  <el-button size="small" type="primary" @click="openZyzDetail(item.gb,item.zyz,
                  index,item)"
                  style="margin-top:10px;">专业组详情
                  <span v-if="item.isShowZyzDetail===false" class="el-icon-arrow-down"></span>
                  <span v-else class="el-icon-arrow-up"></span>
                  </el-button>
                  <div style="margin-top:10px;margin-bottom:10px;" class="art-btns">
                   <button
                    type="button"
                    class="deleteSchool"
                    @click="deleteSchool(item)"
                    v-if="item.collect"
                  >
                  取消收藏
                </button>
                <button
                  type="button"
                  class="addSchool"
                  :disabled="zyzAddCollect"
                  @click="addSchool(item)"
                  v-else
                >
                  加入收藏
                </button>
                  </div>
                  </td>
                </tr>
              </table>
            </div>
            <!-- <div style="display:flex;align-items:center;margin-left:10px;">
              <el-button size="small" type="primary" @click="openZyzDetail(item.gb,item.zyz)">专业组详情
              <span v-if="isShowZyzDetail===false" class="el-icon-arrow-down"></span>
              <span v-else class="el-icon-arrow-up"></span>
              </el-button>
            </div>
            <div style="display:flex;align-items:center;margin-left:10px;" class="art-btns">
                  <button
                  type="button"
                  class="deleteSchool"
                  @click="deleteSchool(item)"
                  v-if="item.collect"
                >
                  取消收藏
                </button>
                <button
                  type="button"
                  class="addSchool"
                  @click="addSchool(item)"
                  v-else
                >
                  加入收藏
                </button>
            </div> -->
          </div>
        </div>
                <div v-show="item.isShowZyzDetail" style="" class="art-content1">
                       <div class="item-zyjs" style="width:850px">
                        <div class="item-title">
                            <!-- <label>院校+专业组计划数</label> -->
                            <label>院校专业组详情</label>
                        </div>
                        <!-- <div class="info-data-wrap">
                            <table class="info-data">
                                <tr>
                                    <th width="5%">年度</th>
                                    <th>专业名称</th>  
                                    <th>专业组</th>
                                    <th>专业类别</th>  
                                    <th>招生批次</th>
                                    <th>计划数</th>  
                                    <th>再选科目要求</th>
                                    <th>学制</th>  
                                    <th>收费标准</th>
                                </tr>
                                <tr v-if="yxZyzPlan.length === 0"> <td colspan="9">暂无数据</td></tr>
                                <tr v-for="(planB,index) in yxZyzPlan" :key="index">
                                    <td>{{ planB.nd }}</td>
                                    <td>{{ planB.zymc }}</td>
                                    <td>{{ planB.zyz }}</td>
                                    <td>{{ planB.zylb }}</td>
                                    <td>{{ planB.pc===0?'本科提前批':'专科提前批' }}</td>
                                    <td>{{ planB.jhs }}</td>
                                    <td>{{ planB.zxkmyq }}</td>
                                    <td>{{ planB.xz }}</td>
                                    <td>{{ planB.xf }}</td>
                                </tr>
                            </table>
                        </div> -->
                      </div> 

                      <div id="outZyTab">
                        <el-table :data="zyTabList" border size="small" max-height="770"
                         :span-method="objectSpanMethod" :cell-style="objectCellMethod"
                        :header-cell-style="{'background-color':'#f5f7fa','border': '1px solid #09F',
                        'color': 'rgb(144, 147, 153)','text-align':'center','font-weight':'700','font-size':'14px'}">
                          <el-table-column label="专业名称" prop="zymc" :resizable="false" align="center"></el-table-column>
                          <el-table-column label="年份" prop="nd" :resizable="false" align="center">
                            <template slot-scope="scope">
                              <span v-if="scope.row.nd>0">{{ scope.row.nd }}</span>
                              <span v-if="scope.row.nd==0"> 平均 </span>
                            </template>
                          </el-table-column>
                          <el-table-column label="我的综合成绩" prop="equivalent"
                            :resizable="false" align="center"></el-table-column>
                          <el-table-column label="批次" prop="pc" :resizable="false" align="center">
                            <template slot-scope="scope">
                              <span v-if="scope.row.pc==0||scope.row.pc=='0'">本科提前批</span>
                              <span v-if="scope.row.pc==7||scope.row.pc=='7'">高职专科批</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="计划人数" :resizable="false" align="center">
                            <el-table-column label="历年" prop="snjhs" :resizable="false" align="center"> </el-table-column>
                            <el-table-column label="今年" prop="jnjhs" :resizable="false" align="center"></el-table-column>
                          </el-table-column>
                          <el-table-column label="专业" :resizable="false" align="center">
                            <template slot-scope="scope">
                              <el-button @click="addTianBaoSchool(scope.row,item)" size="small"
                              type="primary" style="background-color:rgb(4, 121, 245);color:white;
                              border:rgb(4, 121, 245)">{{ scope.row.zyBtnTxt }}</el-button>
                            </template>
                          </el-table-column>
                          <el-table-column label="是否服从" :resizable="false" align="center">
                            <template >
                              <span>服从</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>

                    <!-- <div class="item-zyjs">
                        <div class="item-title">
                            <label>在湘投档线</label>
                        </div>
                        <div class="info-data-wrap">
                            <div class="enrollContainer" >
                                <el-table :data="tdxList" border max-height="500" empty-text size="small" >
                                    <el-table-column align="center" prop="nd" label="年度" ></el-table-column>
                                    <el-table-column align="center" prop="pc" label="批次">
                                      <template slot-scope="scope">
                                        <span v-if="scope.row.pc===0">本科提前批</span>
                                        <span v-else>专科提前批</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="zyz" label="专业组"></el-table-column>
                                    <el-table-column align="center" prop="tdx" label="投档线"></el-table-column>
                                    <el-table-column align="center" prop="equivalent" label="我的成绩"></el-table-column>
                                    <el-table-column align="center" prop="minWhcj" label="最低文化成绩"></el-table-column>
                                    <el-table-column align="center" prop="minZycj" label="最低专业成绩"></el-table-column>
                                    <el-table-column align="center" prop="kl" label="科类">
                                      <template slot-scope="scope">
                                        <span v-if="scope.row.kl===1">历史</span>
                                        <span v-if="scope.row.kl===2">物理</span>
                                        <span v-if="scope.row.kl===0">不分科</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="lb" label="专业类别"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="item-zyjs">
                        <div class="item-title">
                            <label>录取数据</label>
                        </div>
                        <div class="info-data-wrap">
                            <div class="enrollContainer" >
                                <el-table :data="lqsj" max-height="500" empty-text size="small">
                                    <el-table-column align="center"  width="50" prop="nd" label="年度" ></el-table-column>
                                    <el-table-column align="center" width="90" prop="pc" label="批次">
                                      <template slot-scope="scope">
                                        <span v-if="scope.row.pc===0">本科提前批</span>
                                        <span v-else>专科提前批</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column align="center" width="60" prop="minWh" label="最低文化成绩"></el-table-column>
                                    <el-table-column align="center" label="专业成绩">
                                        <el-table-column align="center" width="60" prop="minZy" label="最低"></el-table-column>
                                        <el-table-column align="center" width="60" prop="rankZy" label=排名></el-table-column>
                                    </el-table-column>
                                    <el-table-column align="center" label="综合成绩">
                                        <el-table-column align="center" width="60" prop="minZh" label="最低"></el-table-column>
                                        <el-table-column align="center" width="60" prop="avgZh" label=平均></el-table-column>
                                        <el-table-column align="center" width="60" prop="maxZh" label=最高></el-table-column>
                                    </el-table-column>
                                    <el-table-column align="center" prop="kl" width="60" label="科目">
                                      <template slot-scope="scope">
                                        <span v-if="scope.row.kl===0">不分科</span>
                                        <span v-if="scope.row.kl===1">历史</span>
                                        <span v-if="scope.row.kl===2">物理</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column align="center" prop="zymc" width="120" label="专业名称"></el-table-column>
                                    <el-table-column align="center" prop="zylb" width="80" label="专业类别"></el-table-column>
                                    <el-table-column align="center" prop="bz" label="备注"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="item-zyjs">
                        <div class="item-title">
                            <label>院校专业计划数</label>
                             <div style="width:150px;">
                                <el-select v-model="MaxValueJh" @change="changeJh">
                                    <el-option
                                    v-for="(item,index) in jhndList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info-data-wrap">
                            <table class="info-data">
                                <tr>
                                    <th width="5%">年度</th>
                                    <th>专业名称</th>  
                                    <th>专业类别</th>  
                                    <th>招生批次</th>
                                    <th>计划数</th>  
                                    <th>学制</th>  
                                    <th>收费标准</th>
                                </tr>
                                <tr v-for="(zyJhs,index) in lqjsDetali" :key="index">
                                    <td>{{ zyJhs.nd }}</td>
                                    <td>{{ zyJhs.zymc }}</td>
                                    <td>{{ zyJhs.zylb }}</td>
                                    <td>{{ zyJhs.pc===0?'本科提前批':'专科提前批'}}</td>
                                    <td>{{ zyJhs.jhs }}</td>
                                    <td>{{ zyJhs.xz }}</td>
                                    <td>{{ zyJhs.xf }}</td>
                                </tr>
                            </table>
                        </div>
                    </div> -->
        </div>
      </div> 
        <!-- <div v-show="isShowZyzDetail" style="" class="art-content1">
                              <div class="item-zyjs">
                        <div class="item-title">
                            <label>院校+专业组计划数</label>
                        </div>
                        <div class="info-data-wrap">
                            <table class="info-data">
                                <tr>
                                    <th width="5%">年度</th>
                                    <th>专业名称</th>  
                                    <th>专业组</th>
                                    <th>专业类别</th>  
                                    <th>招生批次</th>
                                    <th>计划数</th>  
                                    <th>再选科目要求</th>
                                    <th>学制</th>  
                                    <th>收费标准</th>
                                </tr>
                                <tr v-if="yxZyzPlan.length === 0"> <td colspan="9">暂无数据</td></tr>
                                <tr v-for="(planB,index) in yxZyzPlan" :key="index">
                                    <td>{{ planB.nd }}</td>
                                    <td>{{ planB.zymc }}</td>
                                    <td>{{ planB.zyz }}</td>
                                    <td>{{ planB.zylb }}</td>
                                    <td>{{ planB.pc }}</td>
                                    <td>{{ planB.jhs }}</td>
                                    <td>{{ planB.zxkmyq }}</td>
                                    <td>{{ planB.xz }}</td>
                                    <td>{{ planB.xf }}</td>
                                </tr>
                            </table>
                        </div>
                    </div> 
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>在湘投档线</label>
                        </div>
                        <div class="info-data-wrap">
                            <div class="enrollContainer" >
                                <el-table :data="tdxList" border max-height="500" empty-text size="small" >
                                    <el-table-column align="center" prop="nd" label="年度" ></el-table-column>
                                    <el-table-column align="center" prop="pc" label="批次"></el-table-column>
                                    <el-table-column align="center" prop="zyz" label="专业组"></el-table-column>
                                    <el-table-column align="center" prop="tdx" label="投档线"></el-table-column>
                                    <el-table-column align="center" prop="equivalent" label="我的成绩"></el-table-column>
                                    <el-table-column align="center" prop="minWhcj" label="最低文化成绩"></el-table-column>
                                    <el-table-column align="center" prop="minZycj" label="最低专业成绩"></el-table-column>
                                    <el-table-column align="center" prop="kl" label="科类"></el-table-column>
                                    <el-table-column align="center" prop="lb" label="专业类别"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>录取数据</label>
                        </div>
                        <div class="info-data-wrap">
                            <div class="enrollContainer" >
                                <el-table :data="lqsj" max-height="500" empty-text size="small">
                                    <el-table-column align="center"  width="50" prop="nd" label="年度" ></el-table-column>
                                    <el-table-column align="center" width="90" prop="pc" label="批次"></el-table-column>
                                    <el-table-column align="center" width="60" prop="minWh" label="最低文化成绩"></el-table-column>
                                    <el-table-column align="center" label="专业成绩">
                                        <el-table-column align="center" width="60" prop="minZy" label="最低"></el-table-column>
                                        <el-table-column align="center" width="60" prop="rankZy" label=排名></el-table-column>
                                    </el-table-column>
                                    <el-table-column align="center" label="综合成绩">
                                        <el-table-column align="center" width="60" prop="minZh" label="最低"></el-table-column>
                                        <el-table-column align="center" width="60" prop="avgZh" label=平均></el-table-column>
                                        <el-table-column align="center" width="60" prop="maxZh" label=最高></el-table-column>
                                    </el-table-column>
                                    <el-table-column align="center" prop="kl" width="60" label="科目"></el-table-column>
                                    <el-table-column align="center" prop="zymc" width="120" label="专业名称"></el-table-column>
                                    <el-table-column align="center" prop="zylb" width="80" label="专业类别"></el-table-column>
                                    <el-table-column align="center" prop="bz" label="备注"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="item-zyjs">
                        <div class="item-title">
                            <label>院校专业计划数</label>
                             <div style="width:150px;">
                                <el-select v-model="MaxValueJh" @change="changeJh">
                                    <el-option
                                    v-for="(item,index) in jhndList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="info-data-wrap">
                            <table class="info-data">
                                <tr>
                                    <th width="5%">年度</th>
                                    <th>专业名称</th>  
                                    <th>专业类别</th>  
                                    <th>招生批次</th>
                                    <th>计划数</th>  
                                    <th>学制</th>  
                                    <th>收费标准</th>
                                </tr>
                                <tr v-for="(zyJhs,index) in lqjsDetali" :key="index">
                                    <td>{{ zyJhs.nd }}</td>
                                    <td>{{ zyJhs.zymc }}</td>
                                    <td>{{ zyJhs.zylb }}</td>
                                    <td>{{ zyJhs.pc }}</td>
                                    <td>{{ zyJhs.jhs }}</td>
                                    <td>{{ zyJhs.xz }}</td>
                                    <td>{{ zyJhs.xf }}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
        </div> -->
    </div>
    <div v-else :class="{'school-out-div':artSchoolCondition.condition===2}">
      <div
        class="school-info"
        :class="{'school-info-other':artSchoolCondition.condition===2}"
        v-for="(item, index) in schoolData.data.records"
        :key="index"
      >
        <div class="info-logo">
          <router-link
            tag="a"
            target="_blank"
            :to="{
              path: '/main/schoolDetail/' + $route.name,
              query: { item: item.gb }
            }"
          >
            <img :src="item.logo" alt="院校logo" width="100%" height="100%" />
          </router-link>
        </div>
        <div class="info-introduce" :class="{'info-introduce-other':artSchoolCondition.condition===2}">
          <div class="school-name">
            <router-link
              tag="a"
              target="_blank"
              :to="{
                path: '/main/schoolDetail/' + $route.name,
                query: { item: item.gb }
              }"
            >
              <h3>{{ item.yxmc }}</h3>
            </router-link>
            <div class="school-lqgl" v-if="$route.path === '/main/yshSchoolRecommend'">
              (录取率:{{ item.lqgl }}%)
            </div>
          </div>
          <div class="school-category">
            <div class="category-wrap category-type">
              <div class="category-item top-positon">
                院校性质:
                <span v-if="item.sfgb !== '0'">公办&nbsp;</span>
                <span v-else-if="item.sfmb !== '0'">民办&nbsp;</span>
                <span v-else-if="item.sfdl !== '0'">独立学院&nbsp;</span>
                <span v-else>暂无信息</span>
              </div>
              <div class="category-item top-positon">
                院校属性:
                <span v-if="item.sf985 !== '0'">985&nbsp;</span>
                <span v-if="item.sf211 !== '0'">211&nbsp;</span>
                <span v-else>普通高校</span>
              </div>
              <div class="category-item top-positon">
                所在省份:{{ item.yxdq }}
              </div>
              <div class="category-item">
                <button
                  type="button"
                  class="deleteSchool"
                  @click="deleteSchool(item)"
                  v-if="item.collect"
                >
                  取消收藏
                </button>
                <button
                  type="button"
                  class="addSchool"
                  :disabled="zyzAddCollect"
                  @click="addSchool(item)"
                  v-else
                >
                  加入收藏
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { addCollectSchool, removeCollectSchool, getSchoolDetail } from "../../api/index";
import { mapState } from "vuex";
import {SCHOOL_FINDER_DATA} from "../../store/mutation-types.js";
export default {
  name: "SchoolsData",
  props: ["istype", "pageId"],
  data() {
    return {
      artSchoolCondition:{},
      isShowZyzDetail:false,
      yxZyzPlan:[],
      tdxList:[],
      lqsj:[],
      zyjhs:[],
      ndList:[],
      zyTabList:[],
      module:{},
      detail:{},
      zyzAddCollect:false
    };
  },
  computed: {
    ...mapState(["schoolData", "userInfo"])
  },
  methods: {
    // 点击打开专业组详情
  async  openZyzDetail(gb,zyz,index,obj){
      await this.loadZyzDetail(gb,zyz,obj.createPc,obj.collect);
      const list=[...this.schoolData.data.records];
      if(!list[index].isShowZyzDetail){
        for(let i=0;i<list.length;i++){
          if(list[i]){
            list[i].isShowZyzDetail=false;
          }
        }
        list[index].isShowZyzDetail=true;
      }else{
        list[index].isShowZyzDetail=false;
      }
      // this.$forceUpdate();
      this.schoolData.data.records=list;
    },
  async  loadZyzDetail(gb,zyz,pc,collect){
                // const result = await getSchoolDetail(gb,zyz);
                const result = await this.module.getSchoolDetail(gb,zyz,pc);
                if(result.data.code === 200){
                    this.detail = result.data.data;
                    this.lqsj = result.data.data.lqsj;
                    this.tdxList = result.data.data.tdx;
                    this.yxZyzPlan = result.data.data.yxZyzPlan;
                    let ndList = result.data.data.list; 
                    let zyjhs = result.data.data.listPlan;
                    let tdxList=result.data.data.tdx;
                    let zyList=result.data.data.zyList;
                    let sczyList=[...new Set([...result.data.data.sczyList])];
                    let yxZyzPlan=result.data.data.yxZyzPlan;
                    let arrNd = [];
                    let arrzyjhs = [];
                    let totalZyData=[];
                    let maxZyDataMaxNd=0;
                    for(let i=0;i<zyjhs.length;i++){
                      if(zyjhs[i]&&zyjhs[i].zymc&&zyjhs[i].zylb==this.userInfo.zylb){
                        const obj={};
                        obj.zymc=zyjhs[i].zymc;
                        const zymcFlagObj=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==zyjhs[i].zymc;
                        });
                        if(!zymcFlagObj){
                          totalZyData.push(obj);
                        }
                        if(zyjhs[i].nd>maxZyDataMaxNd){
                          maxZyDataMaxNd=zyjhs[i].nd;
                        }
                      }
                    }
                    console.log(totalZyData);
                    const arr2=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i].zymc){
                        const obj3={...totalZyData[i]};
                        arr2.push(obj3);
                      }
                    }
                    const arr3=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i].zymc){
                        const obj4={...totalZyData[i]};
                        arr3.push(obj4);
                      }
                    }
                    const arr4=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i].zymc){
                        const obj5={...totalZyData[i]};
                        arr4.push(obj5);
                      }
                    }
                    // 33 73 49
                    totalZyData=[...totalZyData,...arr2,...arr3,...arr4];
                    let ndCountArr=[];
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i]&&totalZyData[i].zymc){
                        const ndCountFlagObj=ndCountArr.find(item=>{
                          return item&&item.zymc&&item.zymc==totalZyData[i].zymc;
                        });
                        if(!ndCountFlagObj){
                          const obj1={};
                          obj1.zymc=totalZyData[i].zymc;
                          obj1.count=1;
                          totalZyData[i].nd=maxZyDataMaxNd-obj1.count;
                          ndCountArr.push(obj1);
                        }else if(ndCountFlagObj.count<=2){
                          ndCountFlagObj.count++;
                          totalZyData[i].nd=maxZyDataMaxNd-ndCountFlagObj.count;
                        }else{
                          totalZyData[i].nd=0;
                        }
                      }
                    }
                    for(let i=0;i<totalZyData.length;i++){
                      if(totalZyData[i]&&totalZyData[i].zymc){
                        totalZyData[i].equivalent=tdxList[0].equivalent;
                        totalZyData[i].pc=tdxList[0].pc;
                        const zyObj1=zyjhs.find(item=>{
                          return item&&item.zymc==totalZyData[i].zymc&&item.nd==maxZyDataMaxNd
                          &&item.zylb==this.userInfo.zylb;
                        });
                        const zyObj2=zyjhs.find(item=>{
                          return item&&item.zymc==totalZyData[i].zymc&&item.nd==totalZyData[i].nd
                          &&item.zylb==this.userInfo.zylb;
                        });
                        console.log(zyObj1,zyObj2);
                        console.log(totalZyData[i]);
                        totalZyData[i].jnjhs=zyObj1?zyObj1.jhs:null;
                        totalZyData[i].snjhs=zyObj2?zyObj2.jhs:null;
                      }
                    }
                    // 0 4 8 12 1->4 2->8 3->12
                    let totalZyData2=[];
                    for(let i=0;i<ndCountArr.length;i++){
                      if(ndCountArr[i]&&ndCountArr[i].zymc){
                        if(i==0){
                          ndCountArr[i].minIndex=0;
                        }else if(i>0){
                          ndCountArr[i].minIndex=i*4;
                        }
                      }
                    }
                    for(let i=0;i<ndCountArr.length;i++){
                      if(ndCountArr[i]&&ndCountArr[i].zymc){
                        const obj11=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==maxZyDataMaxNd-1;
                        });
                        const obj12=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==maxZyDataMaxNd-2;
                        });
                        const obj13=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==maxZyDataMaxNd-3;
                        });
                        const obj14=totalZyData.find(item=>{
                          return item&&item.zymc&&item.zymc==ndCountArr[i].zymc&&item.nd==0;
                        });
                        totalZyData2[ndCountArr[i].minIndex]=obj11;
                        totalZyData2[ndCountArr[i].minIndex+1]=obj12;
                        totalZyData2[ndCountArr[i].minIndex+2]=obj13;
                        totalZyData2[ndCountArr[i].minIndex+3]=obj14;
                      }
                    }
                    // 3->0 8->7
                    for(let i=0;i<totalZyData2.length;i++){
                      if(totalZyData2[i]&&totalZyData2[i].zymc){
                        totalZyData2[i].yxmc=result.data.data.yxmc||'';
                        totalZyData2[i].gb=result.data.data.gb||'010';
                        totalZyData2[i].zyz=yxZyzPlan[0].zyz||'020';
                        totalZyData2[i].pc=tdxList[0].pc<0?'030':tdxList[0].pc;
                        totalZyData2[i].zyBtnTxt='填报';
                        totalZyData2[i].collect=collect;
                      }
                    }
                    let collectZys=[];
                    for(let i=0;i<totalZyData2.length;i++){
                      for(let j=0;j<zyList.length;j++){
                        if(totalZyData2[i].zymc==zyList[j].zymc){
                          totalZyData2[i].zydh=zyList[j].zydh;
                          totalZyData2[i].sfRecruitStudents=true;
                        }else if(totalZyData2[i].zymc!=zyList[j].zymc&&j==zyList.length-1
                        &&!(totalZyData2[i].sfRecruitStudents)){
                          totalZyData2[i]=null;
                        }
                      }
                    }
                    totalZyData2=totalZyData2.filter(item=>{
                      return item!=null;
                    });
                    for(let i=0;i<totalZyData2.length;i++){
                      for(let j=0;j<collectZys.length;j++){
                        if(totalZyData2[i]&&totalZyData2[i].zymc
                        &&totalZyData2[i].zymc==collectZys[j].zymc){
                          totalZyData2[i].zyBtnTxt='专业'+collectZys[j].zyXh;
                        }
                      }
                    }
                    for(let i=0;i<sczyList.length;i++){
                      for(let j=0;j<totalZyData2.length;j++){
                        if(sczyList[i]==totalZyData2[j].zydh){
                          totalZyData2[j].zyBtnTxt='专业'+(i+1);
                        }
                      }
                    }
                    this.zyTabList=totalZyData2;
                    ndList.map((item,i)=>{ arrNd.push(item.nd); });
                    zyjhs.map((item,i)=>{
                        arrzyjhs.push(item.nd);
                    });
                    this.jhndList = Array.from(new Set(arrzyjhs))
                    let MaxNdLq = Math.max(...arrNd);
                    if(MaxNdLq === -Infinity) {
                       this.MaxValueLq = '暂无数据'
                    }else {
                        this.MaxValueLq = MaxNdLq
                    }
                    this.lqDetail = ndList.filter((o)=>{
                        return o.nd ==  this.MaxValueLq
                    })
                    let MaxValueJhOne = Math.max(...arrzyjhs);
                    if(MaxValueJhOne === -Infinity) {
                        this.MaxValueJh = '暂无数据'
                    }else {
                        this.MaxValueJh = MaxValueJhOne
                    }    
                    this.lqjsDetali = zyjhs.filter((o)=>{
                        return o.nd ==  Math.max(...arrzyjhs);
                    });           
                }else if(result.data.code===500){
                  if(result.data.message){
                      this.$message({message:result.data.message,type:'error'});
                  }else if(result.data.msg){
                    this.$message({message:result.data.message,type:'error'});
                  }
                }else if(result.status===401){
                      this.$message({message: '登录超时，请重新登录',type:"error"});
                      await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                      this.$router.replace({
                          path: '/main/home',
                          query: {redirect: this.$router.currentRoute.fullPath}
                      });
                }else if(result.data.code===0){
                      this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                      await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                      this.$router.replace({
                          path: '/main/home',
                          query: {redirect: this.$router.currentRoute.fullPath}
                      });
                }else if(result.status===409||result.status===410||result.status===411){
                      this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                      await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                      this.$router.replace({
                          path: '/main/home',
                          query: {redirect: this.$router.currentRoute.fullPath}
                      });
                }
    },
  async  loadZyzDetail11(gb,zyz,pc,collect){
                // const result = await getSchoolDetail(gb,zyz);
                const result = await this.module.getSchoolDetail(gb,zyz,pc);
                if(result.data.code === 200){
                    this.detail = result.data.data;
                    this.lqsj = result.data.data.lqsj;
                    this.tdxList = result.data.data.tdx;
                    this.yxZyzPlan = result.data.data.yxZyzPlan;
                    let ndList = result.data.data.list; 
                    let zyjhs = result.data.data.listPlan;
                    let arrNd = [];
                    let arrzyjhs = [];
                    ndList.map((item,i)=>{ arrNd.push(item.nd); });
                    zyjhs.map((item,i)=>{
                        arrzyjhs.push(item.nd);
                    });
                    this.jhndList = Array.from(new Set(arrzyjhs))
                    let MaxNdLq = Math.max(...arrNd);
                    if(MaxNdLq === -Infinity) {
                       this.MaxValueLq = '暂无数据'
                    }else {
                        this.MaxValueLq = MaxNdLq
                    }
                    this.lqDetail = ndList.filter((o)=>{
                        return o.nd ==  this.MaxValueLq
                    })
                    let MaxValueJhOne = Math.max(...arrzyjhs);
                    if(MaxValueJhOne === -Infinity) {
                        this.MaxValueJh = '暂无数据'
                    }else {
                        this.MaxValueJh = MaxValueJhOne
                    }    
                    this.lqjsDetali = zyjhs.filter((o)=>{
                        return o.nd ==  Math.max(...arrzyjhs);
                    });        
                }else if(result.data.code===500){
                  if(result.data.message){
                      this.$message({message:result.data.message,type:'error'});
                  }else if(result.data.msg){
                    this.$message({message:result.data.message,type:'error'});
                  }
                }else if(result.status===401){
                      this.$message({message: '登录超时，请重新登录',type:"error"});
                      await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                      this.$router.replace({
                          path: '/main/home',
                          query: {redirect: this.$router.currentRoute.fullPath}
                      });
                }else if(result.data.code===0){
                      this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                      await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                      this.$router.replace({
                          path: '/main/home',
                          query: {redirect: this.$router.currentRoute.fullPath}
                      });
                }else if(result.status===409||result.status===410||result.status===411){
                      this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                      await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                      this.$router.replace({
                          path: '/main/home',
                          query: {redirect: this.$router.currentRoute.fullPath}
                      });
                }
    },
    changeJh(nd) {
      let temp = this.detail.listPlan;
      this.lqjsDetali = temp.filter((o)=>{
          return o.nd == nd
      });
      this.$forceUpdate();
    },
    changeLqNd(){},
    MaxValueLq(){},
    lqDetail(){},
    MaxValueJh(){},
    jhndList(){},
    lqjsDetali(){},
    async getApiIndexMethod(){
      const flag=this.$apiFlag;
      if(flag===1||flag===3){
        this.module=await import("../../api/index");
      }else if(flag===2){
        this.module=await import("../../api/index22");
      }
    },
    //添加关注院校
    async addSchool(item) {
      // const result = await addCollectSchool(this.userInfo.yhid, item.gb);
      // const result = await this.module.addCollectSchool(this.userInfo.yhid, item.gb,item.zyz);
      try {
              this.zyzAddCollect=true;
              const result=await this.$http.postHttp("/addUserCollectionYxZyz",{uid:this.userInfo.yhid,
                collegeid:item.gb,zyz:item.zyz,pc:(item.pc||item.createPc),lb:this.userInfo.zylb});
              if (result.data.code === 200) {
                this.$set(item, "collect", true);
              }else if(result.data.code===500){
                    if(result.data.message){
                        this.$message({message:result.data.message,type:'error'});
                    }else if(result.data.msg){
                      this.$message({message:result.data.msg,type:'error'});
                    }
              }else if(result.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(result.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(result.status===409||result.status===410||result.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }
              this.zyzAddCollect=false;
      } catch (error) {
        this.zyzAddCollect=false;
      }

    },
    // 跨行
    objectSpanMethod({row, column, rowIndex, columnIndex }){
            if(columnIndex===0||columnIndex===2||columnIndex===3||
            columnIndex===5||columnIndex===6||columnIndex===7){
                if(rowIndex%4===0){
                    return{
                        rowspan:4,
                        colspan:1
                    };
                }else {
                    return {
                        rowspan:0,
                        colspan:0
                    };
                }
            }
    },
    objectCellMethod({row,column,rowIndex,columnIndex}){
      // 'color':'#ED4A09','font-weight':'bold'
            if(rowIndex%4===3&&columnIndex===7){
                return{'border':'1px solid #09F','text-align':'center',};
            }else{
                return{'border':'1px solid #09F','text-align':'center'};
            }
    },
    // 填报单个专业 专业表格底部线条蓝色加粗(已经实现)
    async addTianBaoSchool(row,item){
      const loading=this.$loading({
        fullScreen:true,
        target:document.getElementById("outZyTab"),
        text:'正在处理中'
      });
      const isSc=row.collect;
      const collegeid=row.gb;
      const pc=row.pc;
      const zydh=row.zydh;
      const zyz=row.zyz;
      const lb=this.userInfo.zylb;
      const uid=this.userInfo.yhid;
      const zyData=[...this.zyTabList];
      let collectZys=[];
      const zyBtnTxt=row.zyBtnTxt;
      let zydhs=[];
      for(let i=0;i<zyData.length;i++){
        if(zyData[i].zymc&&zyData[i].zyBtnTxt
        &&zyData[i].zyBtnTxt.indexOf('专业')>=0){
          const collectObj=collectZys.find(item=>item.zydh==zyData[i].zydh);
          if(collectObj){
            continue;
          }
          const obj16={};
          obj16.zymc=zyData[i].zymc;
          obj16.zyXh=zyData[i].zyBtnTxt.split('专业')&&zyData[i].zyBtnTxt.split('专业').length?
          parseInt(zyData[i].zyBtnTxt.split('专业')[1]):'';
          obj16.zydh=zyData[i].zydh;
          collectZys.push(obj16);
        }
      }
      const obj={
        collegeid,
        lb,
        pc,
        uid,
        // zydh1:zydh,
        // zydh2:'',
        // zydh3:'',
        // zydh4:'',
        // zydh5:'',
        // zydh6:'',
        zyz
      };
      collectZys=collectZys.sort((a,b)=>{
        return a.zyXh-b.zyXh;
      });
      console.log(collectZys);
      console.log(row);
        let maxZyXh=0;
      if(collectZys.length){
        for(let i=0;i<collectZys.length;i++){
          if(collectZys[i]&&collectZys[i].zymc){
            obj['zydh'+(collectZys[i].zyXh)]=collectZys[i].zydh;
            if(collectZys[i].zyXh>maxZyXh){
              maxZyXh=collectZys[i].zyXh;
            }
          }
        }
        if(maxZyXh>5&&row.zyBtnTxt.indexOf('专业')==-1){
          this.$message({
            message:'一个院校专业组最多只能选择6个专业',
            type:'warning'
          });
          return;
        }
        if(maxZyXh>0){
          // 记录该专业代号是否已经保存的标志位
          let overEditZyFlag=false;
          for(let i=1;i<7;i++){
            if(obj['zydh'+i]&&obj['zydh'+i]==row.zydh){
              obj['zydh'+i]=null;
              overEditZyFlag=true;
              break;
            }
          }
          if(!overEditZyFlag){
            obj['zydh'+(parseInt(maxZyXh)+1)]=row.zydh;
          }
        }
      }else{
        obj['zydh1']=row.zydh;
        for(let i=0;i<zyData.length;i++){
          if(zyData[i].zydh==row.zydh){
            zyData[i].zyBtnTxt='专业1';
          }
        }
      }
        // 统计所有专业
        const zydhTotal1=[];
        // 统计所有专业位置
        const zydhPos1=[];
        // 新的专业情况
        let zydhTotal2=[];
        // 新的专业排序情况
        let zydhPos2=[];
      if(row.zyBtnTxt.indexOf('专业')>=0){
        for(let i=0;i<collectZys.length;i++){
          if(collectZys[i].zymc){
            if(zydhTotal1.indexOf(collectZys[i].zydh)==-1){
              const obj17={...collectZys[i]};
              zydhTotal1.push(obj17.zydh);
           }
          }
        }

        for(let i=0;i<zydhTotal1.length;i++){
          if(zydhTotal1[i]){
            zydhPos1.push(i+1);
          }
        }
        zydhTotal2=[...zydhTotal1]
        // zydhPos2=[...zydhPos1];
        for(let i=0;i<zydhTotal2.length;i++){
          if(zydhTotal2[i]==row.zydh){
            zydhTotal2[i]=null; 
            zydhPos2[i]=null;
          }    
        }
        zydhTotal2=zydhTotal2.filter(item=>item!=null);
        for(let i=0;i<zydhTotal2.length;i++){
          if(zydhTotal2[i]&&i<=5){
            zydhPos2.push(i+1);
          }
        }
        zydhPos2=zydhPos2.filter(item=>item!=null);
        if(zydhPos2.length){
          for(let i=1;i<7;i++){
            obj['zydh'+i]=null;
          }
        }
        console.log(zydhTotal1,zydhTotal2,zydhPos1,zydhPos2);
        if(zydhTotal2.length==zydhPos2.length){
          for(let i=0;i<zyData.length;i++){
            for(let j=0;j<zydhTotal2.length;j++){
              if(zyData[i].zydh==zydhTotal2[j]){
                if(zydhPos2[j]>=1&&zydhPos2[j]<=6){
                  zyData[i].zyBtnTxt='专业'+zydhPos2[j];
                  obj['zydh'+(zydhPos2[j])]=zydhTotal2[j];
                }
              }
            }
          }
        }
      }
      if(!row.collect){
          const res=await this.$http.postHttp("/addUserCollectionYxZyz",obj);
        if(res.data.code==200){
          if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:'success'
            });
          }else{
            this.$message({
              message:'操作成功',
              type:'success'
            });
          }
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }

        
      }else{
        const res=await this.$http.postHttp("/updateYhgzYxZyz",obj);
        if(res.data.code==200){
          if(res.data.msg){
            this.$message({
              message:res.data.msg,
              type:'success'
            });
          }else{
            this.$message({
              message:'操作成功',
              type:'success'
            });
          }
          if(row.zyBtnTxt.indexOf('专业')==-1){
            for(let i=0;i<zyData.length;i++){
                if(zyData[i].zymc==row.zymc&&parseInt(maxZyXh)<=5
                &&row.zyBtnTxt.indexOf('专业')==-1){
                  zyData[i].zyBtnTxt='专业'+(parseInt(maxZyXh)+1);
                }
            }
          }else if(row.zyBtnTxt.indexOf('专业')>=0&&zydhPos2.length){
            for(let i=0;i<zyData.length;i++){
              if(zyData[i].zydh==row.zydh){
                zyData[i].zyBtnTxt='填报';
              }
            }
          }else if(row.zyBtnTxt.indexOf('专业')>=0&&zydhPos1.length==1){
            for(let i=0;i<zyData.length;i++){
              if(zyData[i].zydh==row.zydh){
                zyData[i].zyBtnTxt='填报';
              }
            }
          }
          this.zyTabList=zyData;
        }else if(res.data.code==500){
          if(res.data.message){
            this.$message({
              type:"error",
              message:res.data.message
            });
          }else if(res.data.msg){
            this.$message({
              type:"error",
              message:res.data.msg
            });
          }
        }else if(res.status===401){
              this.$message({message: '登录超时，请重新登录',type:"error"});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.data.code===0){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        }else if(res.status===409||res.status===410||res.status===411){
              this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
              await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
              this.$router.replace({
                  path: '/main/home',
                  query: {redirect: this.$router.currentRoute.fullPath}
              });
        } 
      }

      if(!row.collect){
        const schoolData=[...this.schoolData.data.records];
        const yxmc=row.yxmc;
        for(let i=0;i<schoolData.length;i++){
          if(schoolData[i]&&schoolData[i].yxmc
          &&schoolData[i].yxmc==yxmc&&schoolData[i].zyz==zyz){
            schoolData[i].collect=!schoolData[i].collect;
            schoolData[i].isCollect=!schoolData[i].isCollect;
          }
        }
        const schoolObj={...this.schoolData};
        schoolObj.data.records=schoolData
        this.$store.commit(SCHOOL_FINDER_DATA,{schoolData:{...schoolObj}});
        for(let i=0;i<zyData.length;i++){
          if(zyData[i].zymc){
            zyData[i].collect=!zyData[i].collect;
          }
        }
      }
      this.$set(item,"collect",true);
      loading.close();
    },
    async oldCollectZy(){
            if(!row.collect||collectZys.length==0){
        const res=await this.$http.postHttp("/addMnzybDetail",obj);
      if(res.data.code==200){
        if(res.data.msg){
          this.$message({
            message:res.data.msg,
            type:'success'
          });
        }
      }else if(res.data.code==500){
        if(res.data.message){
          this.$message({
            type:"error",
            message:res.data.message
          });
        }else if(res.data.msg){
          this.$message({
            type:"error",
            message:res.data.msg
          });
        }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
      }else{

        const res=await this.$http.postHttp("/updateMnzyDetail",obj);
      if(res.data.code==200){
        if(res.data.msg){
          this.$message({
            message:res.data.msg,
            type:'success'
          });
        }
      }else if(res.data.code==500){
        if(res.data.message){
          this.$message({
            type:"error",
            message:res.data.message
          });
        }else if(res.data.msg){
          this.$message({
            type:"error",
            message:res.data.msg
          });
        }
      }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
      }
    },
    //删除关注院校
    async deleteSchool(item) {
      // const result = await this.module.removeCollectSchool({
      //   yhid: this.userInfo.yhid,
      //   collegeid: item.gb,
      //   zyz:item.zyz
      // });
      const result=await this.$http.deleteHttp("/deleteUserCollectionYxZyz/"+this.userInfo.yhid+
      "/"+(item.gb||item.gbdm)+"/"+item.zyz+"/"+item.pc+"");
      if (result.data.code === 200) {
        this.$set(item, "collect", false);
        // const list=[...this.schoolData.data.records];
        // for(let i=0;i<list.length;i++){
        //   if(list[i].gb==list[i].gb&&list[i].zyz&&list[i].zyz){
        //     list[i].collect=false;
        //   }
        // }
        // const schoolData={...this.schoolData};
        // schoolData.data.records=list;
        // this.$store.commit(SCHOOL_FINDER_DATA,{schoolData});
        const zyTabList=[...this.zyTabList];
        for(let i=0;i<zyTabList.length;i++){
          if(zyTabList[i]&&zyTabList[i].zymc){
            zyTabList[i].zyBtnTxt='填报';
            zyTabList[i].collect=false;
          }
        }
        this.$forceUpdate();
      }else if(result.data.code===500){
            if(result.data.message){
                this.$message({message:result.data.message,type:'error'});
            }else if(result.data.msg){
              this.$message({message:result.data.msg,type:'error'});
            }
      }else if(result.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      } 
    }
  },
  async mounted(){
    this.artSchoolCondition=this.$parent.artSchoolCondition;
    await this.getApiIndexMethod();
  }
};
</script>

<style lang="stylus" scoped>
.school-data-wrap
    width 1100px
    margin 0 auto
    padding 0 30px 15px
    box-sizing border-box
    background-color #ffffff
    .school-info
        display flex
        padding 20px 0
        border-bottom 1px solid #E4E7ED
        .info-logo
            width 100px
            height 100px
        .info-introduce
            width 940px
            padding-left 20px
            box-sizing border-box
            .school-name
                display flex
                align-items center
                font-size 20px
                color #303133
                .school-lqgl
                    margin-left 10px
                    font-size 14px
                    color #f66
            .school-category
                width 920px
                display flex
                font-size 14px
                .category-wrap
                    width 35%
                    color #666
                    .addSchool
                        width 100px
                        height 30px
                        font-size 14px
                        border 1px solid #f90
                        border-radius 5px
                        color #f90
                        background-color #fff
                        outline none
                        cursor pointer
                    .deleteSchool
                        width 100px
                        height 30px
                        font-size 14px
                        border 1px solid #2186de
                        border-radius 5px
                        color #2186de
                        background-color #fff
                        outline none
                        cursor pointer
                    .category-item
                        display inline-block
                        width 150px
                        margin-bottom 10px
                        overflow hidden
                        white-space nowrap
                        text-overflow ellipsis
                    .category-item:last-child
                        position relative
                        top 6px
                    .top-positon
                        margin-top 20px
                .category-type
                    width 100%
                    display flex
                    justify-content space-between
                    align-items center

                .info-data-wrap
                    width 65%
                    .info-data
                        width 100%
                        color #666
                        th
                            border 1px solid  #09F
                            padding 1px 0
                            text-align center
                            background-color #e4f5ff
                        td
                           padding 1px 5px
                           border 1px solid  #09F
                           text-align center
</style>
<style scoped>
.school-info-other{
  margin:15px;
}
.school-info{
    flex-wrap: wrap;
    border-bottom: 2px solid rgb(0,153,255) !important;
}
.school-out-div{
  display: flex;
  flex-wrap: wrap;
}
.info-introduce-other{
  width:320px !important;
}
.school-data-wrap-other{
  width: 980px;
}
.art-btns .deleteSchool{
      width: 100px;
      height: 30px;
      font-size: 14px;
      border: 1px solid #2186de;
      border-radius: 5px;
      color: #2186de;
      background-color: #fff;
      outline: none;
      cursor: pointer;
}
.art-btns .addSchool{
    width: 100px;
    height: 30px;
    font-size: 14px;
    border: 1px solid #f90;
    border-radius: 5px;
    color: #f90;
    background-color: #fff;
    outline: none;
    cursor: pointer;
}
.art-content1 .item-zyjs {
    margin: 20px 0 !important;
}
.art-content1 .item-zyjs .item-title {
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    border-left: 4px solid #409eff;
    font-size: 20px;
    font-weight: 600;
    color: #333;
}
.art-content1 .item-zyjs .info-data-wrap {
    width: 100%;
    margin: 20px auto 0;
    padding-top: 15px;
    font-size: 14px;
    color: #666;
    line-height: 30px;
    border-top: 1px solid #eaeaea;
}
.art-content1 .item-zyjs .info-data-wrap .info-data {
    width: 100%;
    color: #666;
    font-size: 14px;
}
.art-content1 .item-zyjs .info-data-wrap .info-data th{
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    padding: 1px 0;
    text-align: center;
    background-color: #f8f8f9;
}
.art-content1 .item-zyjs .info-data-wrap .info-data td{
      box-sizing: border-box;
    padding: 1px 5px;
    border: 1px solid #dcdfe6;
    text-align: center;
    color: #606266;
    font-size: 12px;
}
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
::v-deep .el-table .el-table__body-wrapper{
  border-bottom:2px solid rgb(0, 153, 255);
}
</style>
